import request from '@/utils/request'

// 获取家人所有关系
export function getFamilyRelationshipList() {
  return request({
    url: '/api/v1/relationship/list',
    baseURL: 'other',
    method: 'get'
  })
}

// 获取登录用户的群下所有群员
export function getUserInfosByAccountId() {
  return request({
    url: '/api/v2/group/userinfos',
    baseURL: 'other',
    method: 'get'
  })
}

// 创建群组，并添加当前用户
export function createUserGroup(data) {
  return request({
    url: `/api/v1/group/userinfo?mac=${data.mac}&accountId=${data.accountId}`,
    baseURL: 'other',
    method: 'post',
    data
  })
}

// 为指定群组添加用户,v2版本家人关系
export function bindGroupFamily(data) {
  return request({
    url: `/api/v2/group/bind?userGroupId=${data.userGroupId}&phone=${data.phone}&relationShip=${data.relationShip}`,
    baseURL: 'other',
    method: 'post',
    data
  })
}

// 在指定群下注册用户
export function addGroupFamily(data) {
  return request({
    url: `/api/v1/group/userinfo/register`,
    baseURL: 'other',
    method: 'post',
    data
  })
}

// 解绑家人关系
export function unBindRelation(query) {
  return request({
    url: `/api/v1/group/remove`,
    baseURL: 'other',
    method: 'delete',
    params: query
  })
}
